<template>
  <v-row>
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col cols="12">
      <b-btn @click="newEmployeeModal = true" variant="success" class="my-2"
        >+ افزودن کارمند جدید +</b-btn
      >
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <template v-slot:header>
          <v-row>
            <v-col cols="8">
              <h6>
                <b-input-group size="md">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                      variant="danger"
                      >حذف</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </h6>
            </v-col>
            <v-col cols="2">
              <vue-excel-xlsx
                style="width: 135px; height: 35px"
                class="darkGreen-mainBtn mb-3 ms-5 float-end"
                depressed
                :class="employees.length ? 'white--text' : 'disabled-excel'"
                :data="employees"
                :columns="employeesFieldsExcel"
                :file-name="`لیست کارمندان`"
                :sheet-name="`لیست کارمندان`"
              >
                <v-icon
                  class="me-1"
                  :class="employees.length ? 'white--text' : ''"
                >
                  mdi-file-excel-outline
                </v-icon>
                خروجی اکسل</vue-excel-xlsx
              >
            </v-col>
            <v-col cols="2">
              <v-btn
                @click="printReceipt"
                :disabled="gettingReceipt || !employees.length"
                style="width: 135px; height: 35px"
                class="white--text darkRed-mainBtn ms-5 float-end"
                depressed
              >
                <v-icon class="me-1"> mdi-printer </v-icon>
                پرینت
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <b-table
          responsive
          show-empty
          :filter="filter"
          :items="computedEmployees"
          :fields="employeesFields"
          :current-page="currentPage"
          :per-page="perPage"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
        >
          <template v-slot:head()="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div dir="ltr" style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + perPage * (currentPage - 1) + 1 }}
            </div>
          </template>
          <!-- <template v-slot:cell(role)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ roles.filter((x) => x.value == data.value)[0].text }}
            </div>
          </template> -->
          <!-- <template v-slot:cell(status)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + perPage * (currentPage - 1) + 1 }}
            </div>
          </template> -->
          <template v-slot:cell(operation)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn class="mx-1" variant="primary" @click="edit(data.item.id)"
                >ویرایش کارمند</b-btn
              >
              <b-btn
                class="mx-1"
                variant="warning"
                @click="changePassword(data.item)"
                >ویرایش رمز عبور</b-btn
              >
            </div>
          </template>
        </b-table>
        <b-pagination
          v-if="computedEmployees.length"
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="computedEmployees.length"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination
      ></b-card>
    </v-col>

    <v-dialog v-model="newEmployeeModal" width="600px">
      <v-card>
        <v-card-title dark>
          <h4>افزودن کارمند جدید</h4>
        </v-card-title>
        <v-card-text class="mt-2 py-0">
          <v-text-field
            type="text"
            label="نام کاربری"
            v-model="newEmployee.username"
            hint="به صورت استاندارد نام کاربری با حروف لاتین است"
            dense
            outlined
            dir="ltr"
          ></v-text-field>
          <v-text-field
            type="text"
            label="نام"
            v-model="newEmployee.name"
            dense
            outlined
          ></v-text-field>
          <v-text-field
            type="text"
            label="نام خانوادگی"
            v-model="newEmployee.lastName"
            dense
            outlined
          ></v-text-field>
          <v-text-field
            dir="ltr"
            type="text"
            label="نام انگلیسی"
            v-model="newEmployee.nameEn"
            dense
            outlined
          ></v-text-field>
          <v-text-field
            dir="ltr"
            type="text"
            label="نام خانوادگی انگلیسی"
            v-model="newEmployee.lastNameEn"
            dense
            outlined
          ></v-text-field>
          <v-text-field
            type="text"
            label="ایمیل (اختیاری)"
            v-model="newEmployee.email"
            dense
            outlined
            dir="ltr"
          ></v-text-field>
          <v-text-field
            type="text"
            label="شماره موبایل (اختیاری)"
            v-model="newEmployee.mobile"
            dense
            outlined
            dir="ltr"
          ></v-text-field>
          <v-select
            label="نقش"
            :items="roles"
            v-model="newEmployee.role"
            outlined
            dense
          />
          <v-text-field
            type="text"
            label="رمز عبور"
            v-model="newEmployee.password"
            hint="کاربر میتواند پس از لاگین رمز عبور خود را عوض کند"
            dense
            outlined
            dir="ltr"
          ></v-text-field>
          <v-checkbox
            v-model="newEmployee.canSendOut"
            label="امکان امضا نامه برای کاربر وجود دارد"
          ></v-checkbox>
          <v-checkbox
            v-model="newEmployee.canChatExternally"
            label="امکان چت با مشتری برای کاربر وجود دارد"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newEmployeeModal = false"
          >
            لغو
          </v-btn>
          <v-btn
            :disabled="
              !newEmployee.username ||
              !newEmployee.name ||
              !newEmployee.lastName ||
              !newEmployee.nameEn ||
              !newEmployee.lastNameEn ||
              !newEmployee.role ||
              !newEmployee.password
            "
            @click="submitNewEmployee()"
            color="primary"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editEmployeeModal" width="600px">
      <v-card>
        <v-card-title dark>
          <h4>
            ویرایش {{ selectedEmployee.name }} {{ selectedEmployee.lastName }}
          </h4>
        </v-card-title>
        <v-card-text class="mt-2 py-0">
          <v-text-field
            type="text"
            label="نام کاربری"
            v-model="selectedEmployee.username"
            disabled
            dense
            outlined
            dir="ltr"
          ></v-text-field>
          <v-text-field
            type="text"
            label="نام"
            v-model="selectedEmployee.name"
            dense
            outlined
          ></v-text-field>
          <v-text-field
            type="text"
            label="نام خانوادگی"
            v-model="selectedEmployee.lastName"
            dense
            outlined
          ></v-text-field>
          <v-text-field
            dir="ltr"
            type="text"
            label="نام انگلیسی"
            v-model="selectedEmployee.nameEn"
            dense
            outlined
          ></v-text-field>
          <v-text-field
            dir="ltr"
            type="text"
            label="نام خانوادگی انگلیسی"
            v-model="selectedEmployee.lastNameEn"
            dense
            outlined
          ></v-text-field>
          <v-text-field
            type="text"
            label="ایمیل (اختیاری)"
            v-model="selectedEmployee.email"
            dense
            outlined
            dir="ltr"
          ></v-text-field>
          <v-text-field
            type="text"
            label="شماره موبایل (اختیاری)"
            v-model="selectedEmployee.mobile"
            dense
            outlined
            dir="ltr"
          ></v-text-field>
          <v-select
            label="نقش"
            :items="roles"
            v-model="selectedEmployee.role"
            outlined
            dense
          />
          <v-select
            label="وضعیت"
            :items="statuses"
            v-model="selectedEmployee.status"
            outlined
            dense
          />
          <v-checkbox
            v-model="selectedEmployee.canSendOut"
            label="امکان امضا نامه برای کاربر وجود دارد"
          ></v-checkbox>
          <v-checkbox
            v-model="selectedEmployee.canChatExternally"
            label="امکان چت با مشتری برای کاربر وجود دارد"
          ></v-checkbox>
        </v-card-text>

        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="editEmployeeModal = false"
          >
            لغو
          </v-btn>
          <v-btn
            :disabled="
              !selectedEmployee.username ||
              !selectedEmployee.name ||
              !selectedEmployee.lastName ||
              !selectedEmployee.nameEn ||
              !selectedEmployee.lastNameEn ||
              !selectedEmployee.role ||
              !selectedEmployee.status
            "
            @click="submitEditEmployee()"
            color="primary"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="changePasswordModal" max-width="600px">
      <v-card>
        <v-card-title dark>
          <h4>
            ویرایش رمز عبور {{ selectedEmployee.name }}
            {{ selectedEmployee.lastName }}
          </h4>
        </v-card-title>
        <v-card-text class="mt-2 py-0">
          <v-text-field
            type="text"
            label="نام کاربری"
            v-model="selectedEmployee.username"
            disabled
            dense
            outlined
            dir="ltr"
          ></v-text-field>

          <v-text-field
            type="text"
            label="رمز عبور جدید"
            v-model="newPassword"
            hint="کاربر میتواند پس از لاگین رمز عبور خود را عوض کند"
            dense
            outlined
            dir="ltr"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="changePasswordModal = false"
          >
            لغو
          </v-btn>
          <v-btn
            :disabled="!newPassword"
            @click="submitChangePassword()"
            color="primary"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-show="false" id="printTable">
      <h3 style="float: right">لیست کارمندان</h3>
      <b-table :items="employees" :fields="employeesFieldsprint">
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
      </b-table>
    </div>
  </v-row>
</template>
<script>
import Axios from "axios";
import md5 from "js-md5";

export default {
  data() {
    return {
      guide: false,
      // NEW EMPLOYEE MODAL VARIABLES
      newEmployeeModal: false,
      printInvoice: {},
      gettingReceipt: false,
      newEmployee: {
        username: "",
        name: "",
        lastName: "",
        password: "",
        email: "",
        mobile: "",
        role: "",
        canSendOut: false,
        canChatExternally: false,
        status: "active",
      },
      roles: [
        { value: "Manager", text: "مدیر" },
        { value: "ceo", text: "مدیرعامل" },
        { value: "secretary", text: "منشی" },
        { value: "trade", text: "کارشناس بازرگانی" },
        { value: "tradeIntern", text: "کارآموز بازرگانی" },
        { value: "tradeHead", text: "کارشناس فنی" },
        { value: "queryOrganizer", text: "بازرس سفارشات" },
        { value: "accountant", text: "حسابدار"},
        { value: "salesManager", text: "مدیر فروش" },
        { value: "factory", text: "مدیر کارخانه" },
        { value: "factoryTechnical", text: "مسئول فنی کارخانه" },
        { value: "qa", text: "QA & DCC" },
        { value: "qc", text: "مدیر کنترل کیفیت و آزمایشگاه" },
        { value: "qcAgent", text: "کنترل کیفی" },
        { value: "qcDocument", text: "سرتیفیکیت" },
        { value: "factoryPacking", text: "مسئول پکینگ" },
        { value: "production", text: "مدیر خط تولید" },
        { value: "delivery", text: "دلیوری" },
        { value: "coldForgingSupervisor", text: "سرپرست فورج سرد" },
        { value: "cuttingNutSupervisor", text: "مهره‌تراش" },
        { value: "coatingSupervisor", text: "داک و پوشش" },
        { value: "threadingSupervisor", text: "سرپرست رزوه زنی" },
        { value: "machiningSupervisor", text: "سرپرست ماشین کاری و فرزکاری" },
        { value: "cncSupervisor", text: "سرپرست CNC" },
        { value: "knittingSupervisor", text: "سرپرست قلاویز زنی و مهره تراشی" },
        { value: "weldingSupervisor", text: "سرپرست جوشکاری" },
        {
          value: "heatTreatmentSupervisor",
          text: "سرپرست عملیات حرارتی و سیاه کاری",
        },
        { value: "hotForgingSupervisor", text: "سرپرست فورج گرم" },
        { value: "dichromateSupervisor", text: "سرپرست داکرومات" },
        { value: "cuttingSupervisor", text: "سرپرست برشکاری" },
        { value: "factoryGeneral", text: "کارمند کارخانه" },
        { value: "warehouse", text: "مسئول کل انبار" },
        { value: "productsWarehouse", text: "مسئول انبار محصولات" },
        { value: "materialsWarehouse", text: "مسئول انبار مواد اولیه" },
        { value: "toolsWarehouse", text: "مسئول انبار ملزومات" },
        { value: "shop", text: "مسئول فروشگاه" },
      ],

      // EDIT EMPLOYEE MODAL VARIABLES
      editEmployeeModal: false,
      selectedEmployee: {
        username: "",
        name: "",
        lastName: "",
        role: "",
        status: "active",
      },
      selectedEmployeeId: "",
      statuses: [
        { value: "active", text: "فعال" },
        { value: "deactive", text: "غیرفعال" },
      ],

      // CHANGE PASSWORD MODAL VARIABLES
      changePasswordModal: false,
      newPassword: "",

      // TABLE VARIABLES
      filter: "",
      employees: [],
      employeesFields: [
        { key: "index", label: "ردیف" },
        { key: "username", label: "نام کاربری" },
        { key: "name", label: "نام" },
        { key: "lastName", label: "نام خانوادگی" },
        { key: "roleName", label: "نقش" },
        { key: "statusName", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      employeesFieldsprint: [
        { key: "index", label: "ردیف" },
        { key: "username", label: "نام کاربری" },
        { key: "name", label: "نام" },
        { key: "lastName", label: "نام خانوادگی" },
        { key: "roleName", label: "نقش" },
        { key: "statusName", label: "وضعیت" },
      ],
      employeesFieldsExcel: [
        { field: "username", label: "نام کاربری" },
        { field: "name", label: "نام" },
        { field: "lastName", label: "نام خانوادگی" },
        { field: "roleName", label: "نقش" },
        { field: "statusName", label: "وضعیت" },
      ],
      currentPage: 1,
      perPage: 10,
    };
  },
  components: {},
  computed: {
    computedEmployees() {
      let filtered = [];
      filtered = this.employees.filter(item => 
        item.username.includes(this.filter) || 
        item.name.includes(this.filter) ||
        item.lastName.includes(this.filter) || 
        this.roles.filter(data => data.value == item.role)[0].text.includes(this.filter) ||
        this.statuses.filter(data => data.value == item.status)[0].text.includes(this.filter) 
      )
      return filtered;
    },
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/user/dashboard",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    getInfo() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/users/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.employees = res.data;
          this.employees.forEach((person) => {
            try {
              person.roleName = this.roles.filter(
                (x) => x.value == person.role
              )[0].text;
            } catch (error) {
              person.roleName = "-";
            }

            try {
              person.statusName = this.statuses.filter(
                (x) => x.value == person.status
              )[0].text;
            } catch (error) {
              person.statusName = "-";
            }
            this.vLoading = false;
          });
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.vLoading = false;
        });
    },
    submitNewEmployee() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/users/new",
        {
          username: this.newEmployee.username,
          password: md5(this.newEmployee.password),
          name: this.newEmployee.name,
          lastName: this.newEmployee.lastName,
          nameEn: this.newEmployee.nameEn,
          lastNameEn: this.newEmployee.lastNameEn,
          email: this.newEmployee.email,
          mobile: this.newEmployee.mobile,
          role: this.newEmployee.role,
          canSendOut: this.newEmployee.canSendOut,
          canChatExternally: this.newEmployee.canChatExternally,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.toast(res.data, "success");
          this.newEmployeeModal = false;
          this.getInfo();
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    edit(itemId) {
      Axios.post(
        this.baseUrl + "/ppkpms/users/id",
        {
          userId: itemId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.selectedEmployee = res.data;
          this.selectedEmployeeId = itemId;
          this.editEmployeeModal = true;
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    submitEditEmployee() {
      Axios.post(
        this.baseUrl + "/ppkpms/users/edit",
        {
          userId: this.selectedEmployeeId,
          name: this.selectedEmployee.name,
          lastName: this.selectedEmployee.lastName,
          nameEn: this.selectedEmployee.nameEn,
          lastNameEn: this.selectedEmployee.lastNameEn,
          email: this.selectedEmployee.email,
          mobile: this.selectedEmployee.mobile,
          role: this.selectedEmployee.role,
          status: this.selectedEmployee.status,
          canSendOut: this.selectedEmployee.canSendOut,
          canChatExternally: this.selectedEmployee.canChatExternally,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.toast(res.data, "success");
          this.editEmployeeModal = false;
          this.getInfo();
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    changePassword(item) {
      this.selectedEmployee = item;
      this.changePasswordModal = true;
      this.newPassword = "";
    },
    submitChangePassword() {
      Axios.post(
        this.baseUrl + "/ppkpms/users/editPassword",
        {
          userId: this.selectedEmployee.id,
          password: md5(this.newPassword),
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.toast(res.data, "success");
          this.changePasswordModal = false;
          this.getInfo();
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    this.getInfo();
    this.role = window.localStorage.getItem("role");
    this.currentUserId = window.localStorage.getItem("userId");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.app-body {
  overflow-x: unset !important;
}
</style>
